import { getSizeFieldsForCategory } from "../../../dashboard/merchant/utils/categoryFormConfig";
import { getProductStockAvailable } from "./productSizes";

export const isProductInStock = (product) => {
  if (!product) return false;
  const sizeFields = getSizeFieldsForCategory(product.category);
  return getProductStockAvailable(product, null, sizeFields) > 0;
};
